import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { Imports } from "src/app/features/imports/models/imports";
import { ImportsStore } from "src/app/features/imports/stores/imports.store";

export interface ImportRouteData {
    label: string;
}

@Injectable({ providedIn: 'root' })
export class ImportMarkerGuard implements CanActivate {
    constructor(
        private importStore: ImportsStore,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const importIdParam = route.paramMap.get('id');
        
        if (!importIdParam) {
            console.error('Import ID Parameter ist erforderlich');
            return false;
        }

        const importId = +importIdParam;

        // Strategie 1: Prüfe Navigation State
        const navigationState = this.router.getCurrentNavigation()?.extras?.state;
        if (navigationState?.['importData']) {
            route.data = {
                ...route.data,
                importData: navigationState['importData']
            };
            console.log('Daten aus Navigation State geladen');
            return true;
        }

        // Strategie 2: Lade aus Store oder Server
        let importObj = this.importStore.getImportByIdFromSubject(importId);

        if (importObj) {
            // Import im Store vorhanden
            this.setImportData(route, importObj);
            console.log('Daten aus Store geladen');
            return true;
        } else {
            // Import muss vom Server geladen werden
            console.log('Lade Import vom Server...');
            return this.importStore.loadImportById(importId).pipe(
                map((importObj) => {
                    this.setImportData(route, importObj);
                    console.log('Daten vom Server geladen');
                    return true;
                }),
                catchError((error) => {
                    console.error('Fehler beim Laden des Imports:', error);
                    // Fallback
                    this.setFallbackData(route, importId);
                    return of(true);
                })
            );
        }
    }

    private setImportData(
        route: ActivatedRouteSnapshot,
        importObj: Imports
    ) {
        const vendorName = importObj.vendorName || 'Unbekannter Lieferant';
        const clientName = importObj.clientName || 'Unbekannter Kunde';

        const importData: ImportRouteData = {
            label: `${vendorName} - ${clientName}`
        };

        route.data = {
            ...route.data,
            importData
        };
    }

    private setFallbackData(
        route: ActivatedRouteSnapshot,
        importId: number
    ) {
        const importData: ImportRouteData = {
            label: `Import #${importId}`
        };

        route.data = {
            ...route.data,
            importData
        };
    }
}